import { number, shape, string } from 'prop-types';

export const shapeOfKeywordData = shape({
    keywordValue: string,
    visits: number,
    adVisits: number,
    newUsers: number,
    newAdUsers: number,
});

export function getKeywordColumnWidth(columnNumber, index) {
    const avgColumnWidth = 100/(columnNumber + 2)//consider title as 3 columns
    if (index === 0) {
      return avgColumnWidth*3;
    } else {
      return avgColumnWidth;
    }
};
